// Simple logger implementation for Phase 1
// Will be enhanced with full logging configuration in later phases

export type LogLevel = 'debug' | 'info' | 'warn' | 'error'

export class Logger {
  private context: string

  constructor(context: string) {
    this.context = context
  }

  private getLogLevel(): LogLevel {
    return (process.env.MIHARU_LOG_LEVEL as LogLevel) || 'info'
  }

  private shouldLog(level: LogLevel): boolean {
    const levels: Record<LogLevel, number> = {
      debug: 0,
      info: 1,
      warn: 2,
      error: 3
    }

    const currentLevel = levels[this.getLogLevel()]
    const messageLevel = levels[level]

    return messageLevel >= currentLevel
  }

  private formatMessage(level: LogLevel, message: string, meta?: unknown): string {
    const timestamp = new Date().toISOString()
    const baseMessage = `[${timestamp}] [${level.toUpperCase()}] [${this.context}] ${message}`
    
    if (meta) {
      return `${baseMessage} ${JSON.stringify(meta)}`
    }
    
    return baseMessage
  }

  debug(message: string, meta?: unknown): void {
    if (this.shouldLog('debug')) {
      console.debug(this.formatMessage('debug', message, meta))
    }
  }

  info(message: string, meta?: unknown): void {
    if (this.shouldLog('info')) {
      console.info(this.formatMessage('info', message, meta))
    }
  }

  warn(message: string, meta?: unknown): void {
    if (this.shouldLog('warn')) {
      console.warn(this.formatMessage('warn', message, meta))
    }
  }

  error(message: string, meta?: unknown): void {
    if (this.shouldLog('error')) {
      console.error(this.formatMessage('error', message, meta))
    }
  }
}